<template>
  <div v-if="visible">
    <v-pagination
      v-model="pagination.currentPage"
      color="primary"
      :total-visible="totalVisible"
      :length="pagination.totalPages"
      prev-icon="navigate_before"
      next-icon="navigate_next"
      @input="handlePage"
    />
  </div>
</template>

<script>
import { isValidObject } from 'corp-front-vue-commons/src/utils/functions'

export default {
  name: 'Paginator',
  props: {
    pagination: {
      type: Object
    },
    totalVisible: {
      type: Number,
      default: () => window.innerWidth <= 420 ? 5 : 7
    }
  },
  computed: {
    visible () {
      return isValidObject(this.pagination) && this.pagination.totalElements > this.pagination.itemsPerPage
    }
  },
  methods: {
    handlePage (page) {
      this.$emit('change', page)
    }
  }
}
</script>
